export default __webpack_public_path__ + "static/media/five.b789b360.png";